import React from 'react'

const ProfessionalDetails : React.FC = () => {
  return (
    <div>ProfessionalDetails</div>
  )
}

export default ProfessionalDetails